import { useQuery } from 'react-query';

import { QueryResponse } from 'api/endPoints/getScheduleQualityScore/types';
import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetCurrentSPI = (params, endpoint?: string) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getCurrentSPI', params],
        queryFn: () => queryFn(params, endpoint),
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId) && Boolean(params.contractId),
    });
};
